import styled from "styled-components";
import ImageBackground from "../../../../assets/images/header.svg";

export const InfoSec = styled.div`
  padding: 10rem 5rem;
  @media screen and (max-width: 414px) {
    padding: 3rem 3rem;
  }

  z-index: 999;
`;
export const InfoContainer = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 1040px;
  margin: 0 auto;
`;
export const BackgroundImage = styled.div`
  background: url(${ImageBackground}) no-repeat center;
  background-size: 1599px;
  height: fit-content;
  margin: 0 auto;
`;
export const InfoRow = styled.div`
  display: flex;
  margin: 0 -1.5rem -1.5rem;
  flex-wrap: wrap-reverse;
  align-items: center;
  flex-direction: ${({ imgStart }) => (imgStart ? "row-reverse" : "row")};
`;
export const InfoColumn = styled.div`
  margin-bottom: 15px;
  padding-right: 15px;
  padding-left: 15px;
  flex: 1;
  max-width: 50%;
  flex-basis: 50%;

  @media screen and (max-width: 768px) {
    max-width: 100%;
    flex-basis: 100%;
    display: flex;
    justify-content: center;
  }
`;
export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 6rem;
  @media screen and (max-width: 768px) {
    padding-bottom: 6.5rem;
  }
`;
export const Img = styled.img`
  padding-right: 0;
  border: 0;
  max-width: 100%;
  vertical-align: middle;
  display: inline-block;
  max-height: 380px;
`;

export const ImgWrapper = styled.div`
  max-width: 555px;
  display: flex;
  justify-content: ${({ start }) => (start ? "flex-start" : "flex-end")};
`;
